module.exports = __webpack_public_path__ + "img/support.2aab51ba.svg";